import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { SOPS_QUERY } from '../graphql/queries'
import { FETCH_SOPS } from '../redux/action-types'
import { cleanupFetchSops } from '../redux/actions'

const useSopsQuery = () => {
  const dispatch = useDispatch()
  const { isFetching, fetchingError, data } = useSelector(
    store => store.sops.sops,
  )
  useCleanupRedux(cleanupFetchSops)

  useEffect(
    () =>
      apolloService.query({
        query: SOPS_QUERY,
        action: FETCH_SOPS,
        dispatch,
      }),
    [dispatch],
  )

  return { isLoading: isFetching, error: fetchingError, data }
}

export default useSopsQuery
